export class AppUtil {

  static focalizarCampo(valor: string) {

    document.getElementById(valor).focus();

  }

  static mascararPis() {
    return {
      keepCharPositions: true,
      mask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, '-', /\d/]
    };
  }

  static mascararCpf() {

    return {
      keepCharPositions: true,
      mask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    };

  }

  static mascararCnpj() {

    return {
      keepCharPositions: true,
      mask: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    };

  }

  static mascararCep() {

    return {
      keepCharPositions: true,
      mask: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]
    };

  }

  static mascararTelefone() {

    return {
      keepCharPositions: true,
      mask: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    };

  }

  static severidade(nivel: string) {

    switch (nivel) {
      case 'a':
        return {
          cor: 'amarelo',
          icone: 'fas fa-exclamation'
        };
      case 'e':
        return {
          cor: 'vermelho',
          icone: 'fas fa-times'
        };
      case 'i':
        return {
          cor: 'ciano',
          icone: 'fas fa-info'
        };
      case 's':
        return {
          cor: 'verde',
          icone: 'fas fa-check'
        };
      default:
        return {
          cor: null,
          icone: null
        };
    }

  }

  static removerEspacos(valor: string) {

    return valor.replace(/ /g, '');

  }

  static removerSinais(valor: string) {

    return valor.replace(/[^\d]/g, '');

  }

  static abrirArquivo(dados: any, nomeArquivo: string, tipo: string = 'application/pdf') {

    const dadosArquivo: Blob = new Blob([dados], { type: tipo });
    const url: string = URL.createObjectURL(dadosArquivo);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = url;
    a.download = nomeArquivo.toLowerCase() + '.pdf';
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(url);

  }

}
